<div *ngIf="formState == 'CONFIG_ERROR'; else form">Dieses Modul ist nicht korrekt konfiguriert. Bitte wenden Sie sich
  an Ihren
  System-Administrator mit der Fehlermeldung "Parameter 'leadSource' fehlt".
</div>

<ng-template #form>
  <form method="post" enctype="multipart/form-data" (ngSubmit)="onSubmit($event)" *ngIf="formState !== 'SUCCESS'">
    <h1 class="blue">Kontaktanfrage</h1>
    <p *ngIf="providerAgentName">

      <strong>{{providerAgentName}}</strong> hat Sie eingeladen, folgendes Formular auszufüllen.<br/>
    </p>
    <p *ngIf="preferredAgentName">
      Nachdem Sie dieses abgesendet haben, meldet sich <strong>{{preferredAgentName}}</strong> gern kurzfristig bei Ihnen, um Ihr weiteres Vorhaben mit Ihnen zu besprechen.
    </p>
    <app-lead-form
      (onValidChange)="formIsValid=$event"
      [formState]="formState"
      [utmSource]="utmSource"
      (files)="files = $event"
      [displayAddress]="displayAddress"
      [displayCustomerAddress]="displayCustomerAddress"
      [enableDocuments]="enableDocuments"
      [isMilesAndMoreCustomer]="isMilesAndMoreCustomer"
      [milesAndMoreServiceNumber]="milesAndMoreServiceNumber"
    ></app-lead-form>
  </form>

  <div *ngIf="formState === 'SUCCESS'" class="w-100 text-center margin-top-4">
    <img src="assets/submit-icon.svg"/>
    <h1 class="black">Vielen Dank für Ihre Kontaktdaten.<br/>
      <span
        *ngIf="preferredAgent;else noAgent">Ihre Daten werden an <br/><strong>{{preferredAgent | agentName }}</strong> übermittelt.</span>
      <ng-template #noAgent>Ihre Daten werden übermittelt.</ng-template>
    </h1>
    <br/>
  </div>
</ng-template>
